/* pp-seo-2026 v2 */
(function(){
  try {
    var h1 = document.querySelector('h1.product__title, .product__title, h1');
    var t = h1 && h1.textContent.trim();
    if (t) {
      document.querySelectorAll('.product__media img, .product-media-container img, .product img, media-gallery img').forEach(function(img){
        var a = (img.getAttribute('alt')||'').trim();
        if (!a) img.setAttribute('alt', t + ' - Pets Paradise Global');
      });
    }
    // Fix homepage empty/duplicate H1 spacing if needed
    document.querySelectorAll('h1').forEach(function(el){
      if (el.textContent && el.textContent.indexOf('DeserveThe')>-1) {
        el.innerHTML = el.innerHTML.replace(/DeserveThe/,'Deserve<br>The');
      }
    });
  } catch(e){}
})();
